<template>
    <el-dialog title="意见建议详情" :visible="visible" :show="show" width="50%" :close-on-click-modal="false"
               @close="close" custom-class="module-dialog">
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
            <el-form-item label="添加人" class="input" prop="addUserName" >
                <span>{{ruleForm.addUserName}}</span>
            </el-form-item>
            <el-form-item label="联系电话" class="input" prop="phone" >
                <span>{{ruleForm.phone}}</span>
            </el-form-item>
            <el-form-item label="意见、建议" prop="suggestion" >
                {{ruleForm.suggestion}}
            </el-form-item>
            <el-form-item label="图片" prop="imgPath">
                <img :src="url+'upload/'+item" v-for="item in fileNameList" alt="" style="width: 200px;height: 200px;margin-right: 20px;">
            </el-form-item>
            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'addOrUpdate',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                    this.loaddingImg();
                }
            },
            rowData(){
                this.ruleForm = this.rowData;
            },
        },
        mounted(){
            this.myHeaders= {
                'Token':this.$storage.get("Token")
            }
        },
        data(){
            return{
                fileNameList:[],
                updateBtn:true,
                url:base.get().url,
                fileUploadUrl:base.get().fileUploadUrl,
                visible:false,
                ruleForm:{
                    title:'',
                    context:'',
                    sortIndex:'',
                    type:'',
                    videoPath:'',
                },
                url:base.get().url,
            }
        },
        methods:{
            close(){
                this.updateBtn = true;
                this.$refs['ruleForm'].resetFields();
                this.$emit("listenToChildEvent",false);
            },
            loaddingImg(){
                this.$http({
                    url: "suggestion/info/"+this.rowData.id,
                    method: "get",
                }).then(({data}) => {
                    this.fileNameList = data.fileNameList;
                });
            }


        }
    }
</script>
<style lang="scss">
    .module-dialog .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }
    .module-dialog .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }
    .module-dialog .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
    }
    .module-dialog .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }
    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
    }
    .detail-form-content img {
        border-radius: 6px;
        object-fit: cover;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
</style>